module.exports = __webpack_public_path__ + "img/cabinet_small.749feabf.svg";